import type { Banner } from '@s4l/stayforlong/marketing/Banner'
import type { ListOfBanner } from '@s4l/stayforlong/marketing/ListOfBanner'

export const BANNER_TYPES = {
  ANNOUNCEMENT: 'announcement-banner',
  BILLBOARD: 'billboard-banner',
  BLOCK: 'block-banner',
  HERO: 'hero-banner',
} as const

export type BannerType = (typeof BANNER_TYPES)[keyof typeof BANNER_TYPES]

export type AnnouncementBannerInformation = NonNullable<
  ReturnType<Banner['getAnnouncementBannerInformation']>
>
export type BillboardBannerInformation = NonNullable<
  ReturnType<Banner['getBillboardBannerInformation']>
>
export type BlockBannerInformation = NonNullable<ReturnType<Banner['getBlockBannerInformation']>>
export type HeroBannerInformation = NonNullable<ReturnType<Banner['getHeroBannerInformation']>>

export type BannerInformation =
  | AnnouncementBannerInformation
  | BillboardBannerInformation
  | BlockBannerInformation
  | HeroBannerInformation

export type BannerTypeToInformation = {
  [BANNER_TYPES.ANNOUNCEMENT]: AnnouncementBannerInformation
  [BANNER_TYPES.BILLBOARD]: BillboardBannerInformation
  [BANNER_TYPES.BLOCK]: BlockBannerInformation
  [BANNER_TYPES.HERO]: HeroBannerInformation
}

export type BannersJSON = ReturnType<ListOfBanner['toJSON']>

export interface UseBannerOptions<T extends keyof BannerTypeToInformation> {
  bannersJSON?: BannersJSON
  bannerType: T
}

export interface UseBannerReturn<T extends keyof BannerTypeToInformation> {
  banner: ReturnType<ListOfBanner['getBannerByType']> | undefined
  bannerInformation: BannerTypeToInformation[T] | undefined
}
